import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "col-span-2 row-span-6 grid grid-cols-3 grid-rows-6" }
const _hoisted_2 = { class: "flex flex-col gap-2 col-start-2 row-start-2 col-span-2 mt-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Link = _resolveComponent("Link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
        return (_openBlock(), _createBlock(_component_Link, {
          to: link.to,
          text: link.text,
          key: `Link-${index}`
        }, null, 8, ["to", "text"]))
      }), 128))
    ])
  ]))
}